import React, {  useEffect } from 'react';
import './Notification.css'; // Stílus hozzáadás

const Notification = ({ message, type, onClose }) => {
  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        onClose();
      }, 2000); // 5 másodperc után bezáródik
      return () => clearTimeout(timer); // Timer törlése, ha a komponens megszűnik
    }
  }, [message, onClose]);

  if (!message) return null;

  return (
    <div className={`notification ${type}`}>
      {message}
    </div>
  );
};

export default Notification;
